import React from "react";
import {
  Button,
  Checkbox,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  Typography,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ocrModel2Agency } from "./Sidebar.jsx";
import {
  toHalfWidth,
  toFullWidthKatakana,
  normalizePurchaseNo,
  normalizePhoneNumber,
} from "./tool";

const momRegProcStatuses = [
  { id: 0, content: "ーーー" },
  { id: 1, content: "受注完了" },
  { id: 2, content: "問合わせ中" },
];

const DO_NOT_EDIT = 99999999; //編集禁止

class MomTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingId: props.enableEdit === false ? DO_NOT_EDIT : null, // MOM登録完了なら編集不可のため編集ボタン非活性化
      editedData: {},
      editedOnlyData: {},
    };
  }

  displayItemErrorOnStatus(itemContent, itemStatus, cotentNullOK) {
    const content =
      itemContent === "" && itemStatus === "ng" && !cotentNullOK
        ? "（未取得）"
        : itemContent;

    return (
      <span
        style={{
          color: itemStatus === "ng" ? "red" : "inherit",
        }}
      >
        {content}
      </span>
    );
  }

  displayCompanyErrorOnStatus(itemContent, itemStatus) {
    const content =
      itemContent === "" && itemStatus === "ng" ? "ー" : itemContent;

    return (
      <span
        style={{
          color: itemStatus === "ng" ? "red" : "inherit",
        }}
      >
        {content}
      </span>
    );
  }

  //************************************************************* */
  // 受注日／出荷予定日の編集
  //************************************************************* */
  handleOnlyItemEdit(key, value) {
    let editedOnlyData = { ...this.state.editedOnlyData };
    editedOnlyData = {
      ...editedOnlyData,
      [key]: value,
    };
    this.setState({ editedOnlyData });
  }

  handleOnlyItemEditOpen() {
    this.props.setIsMomEditting(0);
    this.setState({ editingId: 0 });
  }

  handleOnlyItemEditClose() {
    this.props.setIsMomEditting(null);
    this.setState({ editingId: null, editedOnlyData: {} });
  }

  handleOnlyItemSave() {
    let margeEditedOnlyData = this.props.data.momBaseInfo;
    const { editedOnlyData } = this.state;
    margeEditedOnlyData = { ...margeEditedOnlyData, ...editedOnlyData };
    this.props.onSaveBaseMom(margeEditedOnlyData);
    this.handleOnlyItemEditClose();
  }

  //************************************************************* */
  // 見積番号／注文番号／経由代理店／部署名／担当者名／電話番号／申請書の編集
  //************************************************************* */
  handleItemEdit(id, key, value) {
    const editedData = { ...this.state.editedData };
    editedData[id] = {
      ...editedData[id],
      [key]:
        key === "tel"
          ? normalizePhoneNumber(toHalfWidth(value))
          : key === "purchaseNo"
            ? normalizePurchaseNo(toHalfWidth(value))
            : value,
    };
    this.setState({ editedData });
  }

  handleItemEdit2(id, key, value) {
    const editedData = { ...this.state.editedData };
    editedData[id] = {
      ...editedData[id],
      [key]:
        key === "tel"
          ? normalizePhoneNumber(toHalfWidth(value))
          : key === "purchaseNo"
            ? normalizePurchaseNo(toHalfWidth(value))
            : toFullWidthKatakana(toHalfWidth(value)),
    };
    this.setState({ editedData });
  }

  handleRecordEditOpen(id) {
    this.props.setIsMomEditting(id);
    this.setState({ editingId: id });
  }

  handleRecordEditClose() {
    this.props.setIsMomEditting(null);
    this.setState({ editingId: null, editedData: {} });
  }

  handleRecordSave(id) {
    const { editedData } = this.state;
    const newData = this.props.data.momInfos.map((momData) => {
      if (momData.momInfo.id === id) {
        return {
          ...momData,
          momInfo: { ...momData.momInfo, ...editedData[id] },
        };
      }
      return momData;
    });
    this.props.onSaveMom(newData);
    this.handleRecordEditClose();
  }

  checkDifferencesData(id) {
    const { editedData } = this.state;
    const targetMomData = this.props.data.momInfos.find(
      (momData) => momData.momInfo.id === id
    );

    if (targetMomData) {
      const originalData = targetMomData.momInfo;
      const newData = editedData[id];

      // 比較して違いがある場合は false を返す
      for (let key in newData) {
        if (newData.hasOwnProperty(key) && originalData[key] !== newData[key]) {
          return false;
        }
      }
      return true; // 違いがない場合は true を返す
    }
    return false;
  }

  // compay, tel, city, town, streetのいずれかが空欄の場合は return trud（DB登録不可）
  isDBRegistration(
    isRegistSalesAgentInfo,
    id,
    company,
    tel,
    city,
    town,
    street
  ) {
    if (isRegistSalesAgentInfo === 1) return true;
    const fields = { company, tel, city, town, street };
    const work = Object.keys(fields).map((key) =>
      this.state.editedData[id]?.[key] !== undefined
        ? this.state.editedData[id]?.[key]
        : fields[key]
    );
    return work.some((value) => value === "");
  }

  renderTableHeader() {
    return (
      <TableHead>
        <TableRow style={{ backgroundColor: "lightgrey" }}>
          <TableCell style={{ width: "15%", textAlign: "center" }}>
            見積番号
          </TableCell>
          <TableCell style={{ width: "14%" }}>注文番号</TableCell>
          <TableCell style={{ width: "23%" }}>経由代理店</TableCell>
          <TableCell style={{ width: "23%" }}>部署名</TableCell>
          <TableCell style={{ width: "15%" }}>担当者名</TableCell>
          <TableCell style={{ width: "10%", textAlign: "center" }}>
            申請書
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  renderTableData(
    id,
    purchaseNo,
    agencyOrderNo,
    company,
    department,
    contactPerson,
    pdfFilePath,
    validPurchaseNo,
    validAgencyOrderNo,
    validCompany,
    validDepartment,
    validContactPerson
  ) {
    const isEditing = this.state.editingId === id;

    return (
      <TableRow key={id + agencyOrderNo}>
        {/*****************************************************
          //  見積番号
          *****************************************************/}
        {isEditing ? (
          <TableCell style={{ paddingRight: "4px", textAlign: "center" }}>
            <TextField
              label="見積番号"
              value={
                this.state.editedData[id]?.purchaseNo !== undefined
                  ? this.state.editedData[id]?.purchaseNo
                  : purchaseNo
              }
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              fullWidth
              onChange={(e) =>
                this.handleItemEdit(id, "purchaseNo", e.target.value)
              }
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "purchaseNo", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell style={{ textAlign: "center" }}>
            {this.displayItemErrorOnStatus(purchaseNo, validPurchaseNo, false)}
          </TableCell>
        )}
        {/*****************************************************
           //  注文番号
          *****************************************************/}
        {isEditing ? (
          <TableCell style={{ paddingRight: "4px" }}>
            <TextField
              label="注文番号"
              value={
                this.state.editedData[id]?.agencyOrderNo !== undefined
                  ? this.state.editedData[id]?.agencyOrderNo
                  : agencyOrderNo
              }
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              fullWidth
              onChange={(e) =>
                this.handleItemEdit(id, "agencyOrderNo", e.target.value)
              }
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "agencyOrderNo", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell>
            {this.displayItemErrorOnStatus(
              agencyOrderNo,
              validAgencyOrderNo,
              false
            )}
          </TableCell>
        )}
        {/*****************************************************
           //  経由代理店
          *****************************************************/}
        {isEditing ? (
          <TableCell style={{ padding: "4px" }}>
            <TextField
              label="経由代理店"
              value={
                this.state.editedData[id]?.company !== undefined
                  ? this.state.editedData[id]?.company
                  : company
              }
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              fullWidth
              onChange={(e) =>
                this.handleItemEdit(id, "company", e.target.value)
              }
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "company", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell>
            {this.displayCompanyErrorOnStatus(company, validCompany)}
          </TableCell>
        )}
        {/*****************************************************
           //  部署名
          *****************************************************/}
        {isEditing ? (
          <TableCell style={{ padding: "4px" }}>
            <TextField
              label="部署名"
              value={
                this.state.editedData[id]?.department !== undefined
                  ? this.state.editedData[id]?.department
                  : department
              }
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              fullWidth
              onChange={(e) =>
                this.handleItemEdit(id, "department", e.target.value)
              }
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "department", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell>
            {this.displayItemErrorOnStatus(department, validDepartment, true)}
          </TableCell>
        )}
        {/*****************************************************
           //  担当者名
          *****************************************************/}
        {isEditing ? (
          <TableCell style={{ padding: "4px" }}>
            <TextField
              label="担当者名"
              value={
                this.state.editedData[id]?.contactPerson !== undefined
                  ? this.state.editedData[id]?.contactPerson
                  : contactPerson
              }
              fullWidth
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              onChange={(e) =>
                this.handleItemEdit(id, "contactPerson", e.target.value)
              }
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "contactPerson", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell>
            {this.displayItemErrorOnStatus(
              contactPerson,
              validContactPerson,
              true
            )}
          </TableCell>
        )}
        {/*****************************************************
           //  申請書
          *****************************************************/}
        <TableCell style={{ textAlign: "center" }}>
          <a href={pdfFilePath} target="_blank" rel="noopener noreferrer">
            申請書
          </a>
        </TableCell>
      </TableRow>
    );
  }

  renderTableData2(
    id,
    company,
    address,
    prefectures,
    city,
    town,
    street,
    building,
    tel,
    validAddress,
    validTel,
    isRegistSalesAgentInfo
  ) {
    const isEditing = this.state.editingId === id;
    const isDisabled = this.isDBRegistration(
      isRegistSalesAgentInfo,
      id,
      company,
      tel,
      city,
      town,
      street
    );
    return (
      <TableRow key={id + "_2"}>
        {/*****************************************************
        //  タイトル（住所）
        *****************************************************/}
        <TableCell
          style={{
            backgroundColor: "lightgrey",
            textAlign: "center",
          }}
        >
          住所
          <br />
          電話番号
        </TableCell>

        {/*****************************************************
         //  住所
        *****************************************************/}
        <TableCell colSpan="3">
          {isEditing ? (
            <div style={{ display: "flex" }}>
              <TextField
                label="都道府県"
                style={{
                  marginRight: "8px",
                  marginTop: "6px",
                  marginBottom: "6px",
                  flexGrow: 0,
                }}
                value={
                  this.state.editedData[id]?.prefectures !== undefined
                    ? this.state.editedData[id]?.prefectures
                    : prefectures
                }
                multiline={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={(e) =>
                  this.handleItemEdit(id, "prefectures", e.target.value)
                }
                onCompositionEnd={(e) =>
                  this.handleItemEdit2(id, "prefectures", e.target.value)
                }
              />
              <TextField
                label="市区郡"
                style={{
                  marginRight: "8px",
                  marginTop: "6px",
                  marginBottom: "6px",
                  flexGrow: 0,
                }}
                value={
                  this.state.editedData[id]?.city !== undefined
                    ? this.state.editedData[id]?.city
                    : city
                }
                multiline={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={(e) =>
                  this.handleItemEdit(id, "city", e.target.value)
                }
                onCompositionEnd={(e) =>
                  this.handleItemEdit2(id, "city", e.target.value)
                }
              />
              <TextField
                label="町村"
                style={{
                  marginRight: "8px",
                  marginTop: "6px",
                  marginBottom: "6px",
                  flexGrow: 0,
                }}
                value={
                  this.state.editedData[id]?.town !== undefined
                    ? this.state.editedData[id]?.town
                    : town
                }
                multiline={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={(e) =>
                  this.handleItemEdit(id, "town", e.target.value)
                }
                onCompositionEnd={(e) =>
                  this.handleItemEdit2(id, "town", e.target.value)
                }
              />
              <TextField
                label="番地"
                style={{
                  marginRight: "8px",
                  marginTop: "6px",
                  marginBottom: "6px",
                  flexGrow: 0,
                }}
                value={
                  this.state.editedData[id]?.street !== undefined
                    ? this.state.editedData[id]?.street
                    : street
                }
                multiline={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={(e) =>
                  this.handleItemEdit(id, "street", e.target.value)
                }
                onCompositionEnd={(e) =>
                  this.handleItemEdit2(id, "street", e.target.value)
                }
              />
              <TextField
                label="ビル名"
                style={{
                  marginTop: "6px",
                  marginBottom: "6px",
                  flexGrow: 1,
                }}
                value={
                  this.state.editedData[id]?.building !== undefined
                    ? this.state.editedData[id]?.building
                    : building
                }
                multiline={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onChange={(e) =>
                  this.handleItemEdit(id, "building", e.target.value)
                }
                onCompositionEnd={(e) =>
                  this.handleItemEdit2(id, "building", e.target.value)
                }
              />
            </div>
          ) : (
            <div>
              {prefectures || city || town || street || building ? (
                <>
                  {prefectures} ／ {city} ／ {town} ／ {street} ／ {building}
                  {address !== "" && (
                    <>
                      <br />（{" "}
                      {this.displayItemErrorOnStatus(
                        address,
                        validAddress,
                        true
                      )}
                      ）
                    </>
                  )}
                </>
              ) : null}
            </div>
          )}
        </TableCell>
        {/*****************************************************
             // 電話番号
            *****************************************************/}
        {isEditing ? (
          <TableCell style={{ paddingLeft: "4px" }}>
            <TextField
              label="電話番号"
              value={
                this.state.editedData[id]?.tel !== undefined
                  ? this.state.editedData[id]?.tel
                  : tel
              }
              fullWidth
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              onChange={(e) => this.handleItemEdit(id, "tel", e.target.value)}
              onCompositionEnd={(e) =>
                this.handleItemEdit2(id, "tel", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell>
            {this.displayItemErrorOnStatus(tel, validTel, true)}
          </TableCell>
        )}
        {/*****************************************************
       //  保存／中断／編集
      *****************************************************/}
        <TableCell rowSpan={"2"} style={{ textAlign: "center" }}>
          {isEditing ? (
            <>
              {/* 販社登録 */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(
                      this.state.editedData[id]?.isRegistSalesAgentInfo !==
                        undefined
                        ? this.state.editedData[id]?.isRegistSalesAgentInfo
                        : isRegistSalesAgentInfo
                    )}
                    onChange={(e) => {
                      this.handleItemEdit(
                        id,
                        "isRegistSalesAgentInfo",
                        e.target.checked ? 1 : 0
                      );
                    }}
                    disabled={isDisabled}
                    color="primary"
                  />
                }
                label={
                  <Typography
                    style={{ fontSize: "0.7rem" }}
                    color={isDisabled ? "textSecondary" : "textPrimary"}
                  >
                    DB登録
                  </Typography>
                }
              />

              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.handleRecordSave(id)}
                  disabled={
                    !this.state.editedData[id] || this.checkDifferencesData(id)
                  }
                >
                  保存
                </Button>
              </div>
              <div style={{ margin: "10px" }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={() => this.handleRecordEditClose()}
                  style={{ fontSize: "0.7rem" }}
                >
                  キャンセル
                </Button>
              </div>
            </>
          ) : (
            <>
              <Button
                variant="outlined"
                color="primary"
                disabled={this.state.editingId !== null}
                onClick={() => this.handleRecordEditOpen(id)}
              >
                編集
              </Button>
            </>
          )}
        </TableCell>
      </TableRow>
    );
  }

  renderTableData3(id, remarks, momProcStatus) {
    const isEditing = this.state.editingId === id;

    return (
      <TableRow key={id + "_3"}>
        {/*****************************************************
          //  タイトル（備考／処理状況）
          *****************************************************/}
        <TableCell
          style={{
            backgroundColor: "lightgrey",
            textAlign: "center",
          }}
        >
          備考
          <br />
          処理状況
        </TableCell>
        {/*****************************************************
           //  備考
          *****************************************************/}
        {isEditing ? (
          <TableCell colSpan="3" style={{ paddingRight: "4px" }}>
            <TextField
              label="備考"
              value={
                this.state.editedData[id]?.remarks !== undefined
                  ? this.state.editedData[id]?.remarks
                  : remarks
              }
              fullWidth
              multiline={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              onChange={(e) =>
                this.handleItemEdit(id, "remarks", e.target.value)
              }
            />
          </TableCell>
        ) : (
          <TableCell colSpan="3">
            <div>{remarks}</div>
          </TableCell>
        )}
        {/*****************************************************
           //  処理状況
          *****************************************************/}
        {isEditing ? (
          // {this.state.editingId !== null ? ( // 処理状況をいつでも編集可能にする
          <TableCell colSpan="1" style={{ paddingLeft: "4px" }}>
            <TextField
              select
              label="処理状況"
              defaultValue={
                this.state.editedData[id]?.momProcStatus !== undefined
                  ? this.state.editedData[id]?.momProcStatus
                  : momProcStatus
              }
              value={
                this.state.editedData[id]?.momProcStatus !== undefined
                  ? this.state.editedData[id]?.momProcStatus
                  : momProcStatus
              }
              fullWidth
              onChange={(e) =>
                this.handleItemEdit(id, "momProcStatus", e.target.value)
              }
            >
              {momRegProcStatuses.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.content}
                </MenuItem>
              ))}
            </TextField>{" "}
          </TableCell>
        ) : (
          <TableCell colSpan="1">
            処理状況：
            {
              momRegProcStatuses[
                this.state.editedData[id]?.momProcStatus !== undefined
                  ? this.state.editedData[id]?.momProcStatus
                  : momProcStatus
              ].content
            }
          </TableCell>
        )}
      </TableRow>
    );
  }

  renderTableDataVerification(
    id,
    poCompany,
    poProductNo,
    poOrderCount,
    poMail,
    ofCompany,
    ofProductNo,
    ofOrderCount,
    mfCompany,
    mfMail,
    mfProductName,
    mfProductNo,
    mfOrderCount,
    checkCompany,
    checkMail,
    checkOrderCount,
    checkProductNo
  ) {
    function getColorAndAdjustCount(count, threshold) {
      let color;
      if (count >= threshold) {
        color = "red";
        count -= threshold;
      } else {
        color = "inherit";
      }
      return [color, count];
    }
    // 数量
    let checkOrderCountColor, checkOrderCountColor2, checkOrderCountColor3;
    [checkOrderCountColor, checkOrderCount] = getColorAndAdjustCount(
      checkOrderCount,
      100
    );
    [checkOrderCountColor2, checkOrderCount] = getColorAndAdjustCount(
      checkOrderCount,
      10
    );
    checkOrderCountColor3 = checkOrderCount % 10 === 1 ? "red" : "inherit";

    // 発注者
    let checkCompanyColor, checkCompanyColor2, checkCompanyColor3;
    [checkCompanyColor, checkCompany] = getColorAndAdjustCount(
      checkCompany,
      100
    );
    [checkCompanyColor2, checkCompany] = getColorAndAdjustCount(
      checkCompany,
      10
    );
    checkCompanyColor3 = checkCompany % 10 === 1 ? "red" : "inherit";

    // 発注者メール
    let checkMailColor, checkMailColor3;
    [checkMailColor, checkMail] = getColorAndAdjustCount(checkMail, 100);
    checkMailColor3 = checkMail % 10 === 1 ? "red" : "inherit";

    // 品番
    let checkProductNoColor, checkProductNoColor2, checkProductNoColor3;
    [checkProductNoColor, checkProductNo] = getColorAndAdjustCount(
      checkProductNo,
      100
    );
    [checkProductNoColor2, checkProductNo] = getColorAndAdjustCount(
      checkProductNo,
      10
    );
    checkProductNoColor3 = checkProductNo % 10 === 1 ? "red" : "inherit";

    // 黄色背景の切り替え
    let checkOrderCountBackgroundColor2, checkProductNoBackgroundColor2;

    checkOrderCountBackgroundColor2 =
      checkOrderCountColor2 === "red" ? "yellow" : "#f2f2f2";

    checkProductNoBackgroundColor2 =
      checkProductNoColor2 === "red" ? "yellow" : "#f2f2f2";

    return (
      <>
        <TableRow key={id + "_4"}>
          {/*****************************************************
          //  タイトル（照合チェック）
           *****************************************************/}
          <TableCell
            style={{
              backgroundColor: "lightgrey",
              textAlign: "center",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderBottom: "none",
            }}
          >
            ＜照合項目＞
          </TableCell>
          {/*****************************************************
           //  数量（タイトル
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "lightgrey",
              textAlign: "center",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderBottom: "none",
            }}
          >
            ＜数量＞
          </TableCell>

          {/*****************************************************
           //  発注者（タイトル
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "lightgrey",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderBottom: "none",
            }}
          >
            ＜発注者＞
          </TableCell>
          {/*****************************************************
           //  発注者メール（タイトル
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "lightgrey",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderBottom: "none",
            }}
          >
            ＜発注者メール＞
          </TableCell>

          {/*****************************************************
           //  品番（タイトル
           *****************************************************/}
          <TableCell
            colSpan="2"
            style={{
              backgroundColor: "lightgrey",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderBottom: "none",
            }}
          >
            ＜品番＞
          </TableCell>
        </TableRow>

        <TableRow key={id + "_5"}>
          {/*****************************************************
          //  タイトル（照合チェック）
           *****************************************************/}
          <TableCell
            style={{
              backgroundColor: "lightgrey",
              textAlign: "center",
              paddingTop: "15px",
              paddingBottom: "5px",
              borderBottom: "none",
            }}
          >
            購入申請書
          </TableCell>
          {/*****************************************************
           //  数量（購入申請書
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              textAlign: "center",
              paddingTop: "15px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkOrderCountColor,
            }}
          >
            {poOrderCount === "" ? "（未取得）" : poOrderCount}
          </TableCell>
          {/*****************************************************
           //  発注者（購入申請書
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "15px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkCompanyColor,
            }}
          >
            {poCompany === "" ? "（未取得）" : poCompany}
          </TableCell>
          {/*****************************************************
           //  発注者メール（購入申請書
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "15px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkMailColor,
            }}
          >
            {poMail === "" ? "（未取得）" : poMail}
          </TableCell>
          {/*****************************************************
           //  品番（購入申請書
           *****************************************************/}
          <TableCell
            colSpan="2"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "15px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkProductNoColor,
            }}
          >
            {poProductNo === "" ? "（未取得）" : poProductNo}
          </TableCell>
        </TableRow>

        <TableRow key={id + "_6"}>
          {/*****************************************************
          //  タイトル（照合チェック）
           *****************************************************/}
          <TableCell
            style={{
              backgroundColor: "lightgrey",
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              borderBottom: "none",
            }}
          >
            注文書類
          </TableCell>
          {/*****************************************************
           //  数量（注文書類
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: checkOrderCountBackgroundColor2,
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkOrderCountColor2,
            }}
          >
            {ofOrderCount === "" ? "（未取得）" : ofOrderCount}
          </TableCell>
          {/*****************************************************
           //  発注者（注文書類
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "5px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkCompanyColor2,
            }}
          >
            {ofCompany === "" ? "（未取得）" : ofCompany}
          </TableCell>
          {/*****************************************************
           //  発注者メール（注文書類
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "5px",
              paddingBottom: "5px",
              borderBottom: "none",
            }}
          >
            {"−−−"}
          </TableCell>
          {/*****************************************************
           //  品番（注文書類
           *****************************************************/}
          <TableCell
            colSpan="2"
            style={{
              backgroundColor: checkProductNoBackgroundColor2,
              paddingTop: "5px",
              paddingBottom: "5px",
              borderBottom: "none",
              color: checkProductNoColor2,
            }}
          >
            {ofProductNo === "" ? "（未取得）" : ofProductNo}
          </TableCell>
        </TableRow>
        <TableRow key={id + "_7"}>
          {/*****************************************************
          //  タイトル（照合チェック）
           *****************************************************/}
          <TableCell
            style={{
              backgroundColor: "lightgrey",
              textAlign: "center",
              paddingTop: "5px",
            }}
          >
            MF見積DB
          </TableCell>
          {/*****************************************************
           //  数量（MF見積DB
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              textAlign: "center",
              paddingTop: "5px",
              color: checkOrderCountColor3,
            }}
          >
            {mfOrderCount === "取得中..." ? (
              <span style={{ color: "blue" }}>{mfOrderCount}</span>
            ) : mfOrderCount === "" ? (
              "（未取得）"
            ) : (
              mfOrderCount
            )}
          </TableCell>
          {/*****************************************************
           //  発注者（MF見積DB
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "5px",
              color: checkCompanyColor3,
            }}
          >
            {mfCompany === "取得中..." ? (
              <span style={{ color: "blue" }}>{mfCompany}</span>
            ) : mfCompany === "" ? (
              "（未取得）"
            ) : (
              mfCompany
            )}
          </TableCell>
          {/*****************************************************
           //  発注者メール（MF見積DB
           *****************************************************/}
          <TableCell
            colSpan="1"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "5px",
              color: checkMailColor3,
            }}
          >
            {mfMail === "取得中..." ? (
              <span style={{ color: "blue" }}>{mfMail}</span>
            ) : mfMail === "" ? (
              "（未取得）"
            ) : (
              mfMail
            )}
          </TableCell>
          {/*****************************************************
           //  品番（MF見積DB
           *****************************************************/}
          <TableCell
            colSpan="2"
            style={{
              backgroundColor: "#f2f2f2",
              paddingTop: "5px",
              color: checkProductNoColor3,
            }}
          >
            {mfProductNo === "" ? (
              "（未取得）"
            ) : (
              <>
                {mfProductNo === "取得中..." ? (
                  <span style={{ color: "blue" }}>{mfProductNo}</span>
                ) : (
                  <>
                    {mfProductNo}
                    {mfProductName !== "スタンダードプラン" && (
                      <span style={{ color: "red" }}>{" ＊"}</span>
                    )}
                  </>
                )}
              </>
            )}
          </TableCell>
        </TableRow>
      </>
    );
  }

  renderOnlyItemTableHeader() {
    return (
      <TableHead>
        <TableRow style={{ backgroundColor: "lightgrey" }}>
          <TableCell style={{ width: "15%", textAlign: "center" }}>
            管理番号
          </TableCell>
          <TableCell style={{ width: "14%", textAlign: "center" }}>
            販社
          </TableCell>
          <TableCell style={{ textAlign: "center" }}> 受注日 </TableCell>
          <TableCell style={{ textAlign: "center" }}> 出荷予定日</TableCell>
          <TableCell style={{ textAlign: "center" }}>編集</TableCell>
          <TableCell style={{ width: "15%", textAlign: "center" }}>
            登録者
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  renderOnlyItemTableData(orderDate, shipDate, userEmail) {
    const isEditing = this.state.editingId === 0;

    return (
      <TableRow>
        {/*****************************************************
        //  管理番号
        *****************************************************/}
        <TableCell
          style={{
            backgroundColor: "#f2f2f2",
            textAlign: "center",
          }}
        >
          {this.props.processNo}
        </TableCell>
        {/*****************************************************
        //  流通販社
        *****************************************************/}
        <TableCell
          style={{
            backgroundColor: "#f2f2f2",
            textAlign: "center",
          }}
        >
          {ocrModel2Agency[this.props.data.momInfos[0].momInfo.agency]}
        </TableCell>
        {/*****************************************************
        //  受注日
        *****************************************************/}
        <TableCell
          style={{
            textAlign: "center",
          }}
        >
          {isEditing ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={
                  this.state.editedOnlyData?.orderDate !== undefined
                    ? this.state.editedOnlyData?.orderDate
                    : orderDate
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                fullWidth
                onChange={(date) =>
                  this.handleOnlyItemEdit(
                    "orderDate",
                    date.format("YYYY/MM/DD")
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      value: formatDate(params.inputProps.value),
                      readOnly: true, // 直接入力を不可にする
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          ) : (
            orderDate
          )}
        </TableCell>

        {/*****************************************************
        //  出荷予定日
        *****************************************************/}
        <TableCell
          style={{
            textAlign: "center",
          }}
        >
          {" "}
          {isEditing ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={
                  this.state.editedOnlyData?.shipDate !== undefined
                    ? this.state.editedOnlyData?.shipDate
                    : shipDate
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                fullWidth
                onChange={(date) =>
                  this.handleOnlyItemEdit("shipDate", date.format("YYYY/MM/DD"))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      value: formatDate(params.inputProps.value),
                      readOnly: true, // 直接入力を不可にする
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          ) : (
            shipDate
          )}
        </TableCell>
        {/*****************************************************
         //  保存／中断／編集
        *****************************************************/}
        <TableCell rowSpan={"2"} style={{ textAlign: "center" }}>
          {isEditing ? (
            <>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.handleOnlyItemSave()}
                >
                  保存
                </Button>
                {"　"}
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={() => this.handleOnlyItemEditClose()}
                  style={{ fontSize: "0.7rem" }}
                >
                  キャンセル
                </Button>
              </div>
            </>
          ) : (
            <Button
              variant="outlined"
              color="primary"
              disabled={this.state.editingId !== null}
              onClick={() => this.handleOnlyItemEditOpen()}
            >
              編集
            </Button>
          )}
        </TableCell>
        {/*****************************************************
        //  登録者
        *****************************************************/}
        <TableCell style={{ textAlign: "center", backgroundColor: "#f2f2f2" }}>
          {userEmail.split("@")[0]}
        </TableCell>
      </TableRow>
    );
  }
  render() {
    return (
      <div>
        {/*******************************************************************
           //  代理店／受注日／出荷予定日／登録者
          *******************************************************************/}
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            {this.renderOnlyItemTableHeader()}
            <TableBody>
              {this.renderOnlyItemTableData(
                this.props.data.momBaseInfo.orderDate,
                this.props.data.momBaseInfo.shipDate,
                this.props.data.momBaseInfo.momRegisterMail
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/*******************************************************************
           //  見積番号／注文番号／経由代理店／部署名／担当者名／電話番号／申請書
          *******************************************************************/}
        {this.props.data.momInfos.map((momData, index) => {
          const {
            id,
            purchaseNo,
            agencyOrderNo,
            company,
            department,
            contactPerson,
            address,
            prefectures,
            city,
            town,
            street,
            building,
            tel,
            validPurchaseNo,
            validAgencyOrderNo,
            validCompany,
            validDepartment,
            validContactPerson,
            validAddress,
            validTel,
            pdfFilePath,
            remarks,
            momProcStatus,
            poCompany,
            poProductNo,
            poOrderCount,
            poMail,
            ofCompany,
            ofProductNo,
            ofOrderCount,
            mfCompany,
            mfMail,
            mfProductName,
            mfProductNo,
            mfOrderCount,
            checkCompany,
            checkMail,
            checkOrderCount,
            checkProductNo,
            momApiStatus,
            isRegistSalesAgentInfo,
          } = momData.momInfo;

          return (
            <div style={{ marginTop: "40px" }} key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color:
                      checkCompany !== 0 ||
                      checkMail !== 0 ||
                      checkOrderCount !== 0 ||
                      checkProductNo !== 0 ||
                      validPurchaseNo === "ng" ||
                      validAgencyOrderNo === "ng" ||
                      validCompany === "ng" ||
                      validDepartment === "ng" ||
                      validContactPerson === "ng" ||
                      validAddress === "ng" ||
                      validTel === "ng" ||
                      momApiStatus.length > 2
                        ? "red"
                        : "inherit",
                  }}
                >
                  {"No."}
                  {index + 1}
                  {momApiStatus !== "" && momApiStatus !== "0" ? (
                    <span style={{ fontSize: "0.8em" }}>
                      ：MOM APIエラー（{momApiStatus}）
                    </span>
                  ) : (
                    ""
                  )}
                </span>
                {mfProductName !== "スタンダードプラン" &&
                  mfProductName !== "" && (
                    <span style={{ fontSize: "0.9em", color: "red" }}>
                      {"＊" + mfProductName}
                    </span>
                  )}
              </div>

              <div style={{ marginTop: "10px" }}>
                <TableContainer component={Paper}>
                  <Table>
                    {this.renderTableHeader()}
                    <TableBody>
                      {this.renderTableData(
                        id,
                        purchaseNo,
                        agencyOrderNo,
                        company,
                        department,
                        contactPerson,
                        pdfFilePath,
                        validPurchaseNo,
                        validAgencyOrderNo,
                        validCompany,
                        validDepartment,
                        validContactPerson
                      )}
                      {this.renderTableData2(
                        id,
                        company,
                        address,
                        prefectures,
                        city,
                        town,
                        street,
                        building,
                        tel,
                        validAddress,
                        validTel,
                        isRegistSalesAgentInfo
                      )}
                      {this.renderTableData3(id, remarks, momProcStatus)}
                      {this.renderTableDataVerification(
                        id,
                        poCompany,
                        poProductNo,
                        poOrderCount,
                        poMail,
                        ofCompany,
                        ofProductNo,
                        ofOrderCount,
                        mfCompany,
                        mfMail,
                        mfProductName,
                        mfProductNo,
                        mfOrderCount,
                        checkCompany,
                        checkMail,
                        checkOrderCount,
                        checkProductNo
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

function formatDate(date) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("/");
}

export default MomTable;
export { formatDate };
